import { Box, Flex, Text, Icon } from '@fullstory/components';
import { SortOrder, SortType } from '@fullstory/proto/fs/api/metrics';
import React from 'react';
import { orderAndTypeToLabelMap } from '../../../utils';

interface MetricSortDisplayProps {
  sortType: SortType;
  sortOrder: SortOrder;
  aggregationLabel: string;
}

export const SortDisplay: React.FC<MetricSortDisplayProps> = ({
  sortType,
  sortOrder,
  aggregationLabel,
}) => {
  if (sortType === SortType.SORT_TYPE_INVALID || sortOrder === SortOrder.SORT_ORDER_INVALID)
    return null;

  const label = orderAndTypeToLabelMap(sortType, aggregationLabel)?.[sortOrder];
  if (!label) return null;

  return (
    <Box data-component="SortDisplay" marginBottom={8}>
      <Text appearance="bodySmall" tag="div">
        <Flex justifyContent="flex-start" gap={8}>
          <Icon name="sort" color="secondary" size={20} />
          {label}
        </Flex>
      </Text>
    </Box>
  );
};
